import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ButtonComponentConfig, ButtonSize, ButtonType, IconType } from '@rappider/rappider-components/utils';
import { Page } from '@rappider/rappider-sdk';
import { UpdatePageCss } from '../../state/content-editor.actions';

@Component({
  selector: 'rappider-page-style-customization',
  templateUrl: './page-style-customization.component.html',
  styleUrls: ['./page-style-customization.component.scss']
})
export class PageStyleCustomizationComponent implements OnInit {

  @Input() page: Page;

  cssValue = '';
  localeCssValue = '';

  monacoEditorSettings = {
    language: 'css',
    automaticLayout: true,
    minimap: {
      enabled: false
    },
    formatOnPaste: true,
    formatOnType: true,
    validateOnType: false,
    validateOnPaste: false,
    wordWrap: 'on',
    wrappingStrategy: 'advanced',
    scrollBeyondLastLine: false,
    scrollbar: {
      vertical: 'visible',
      horizontal: 'visible',
      verticalScrollbarSize: 14,
      horizontalScrollbarSize: 14
    }
  };

  monacoAdditionalButtons: ButtonComponentConfig[] = [
    {
      key: 'open-modal',
      icon: {
        name: 'fa-light fa-expand',
        type: IconType.FontAwesome,
        color: 'var(--text-color)'
      },
      size: ButtonSize.Small,
      type: ButtonType.Link
    }
  ];
  modalMode = false;
  /* for handle monaco editor visibility after modal render */
  monacoEditorInModalVisibility = false;

  constructor(private store: Store<any>) { }

  ngOnInit() {
    this.cssValue = this.page?.cssStyle || '';
    this.localeCssValue = this.cssValue;
  }

  onCssValueChange(css: string) {
    this.localeCssValue = css;
  }

  onSaveCss() {
    this.cssValue = this.localeCssValue;
    this.store.dispatch(new UpdatePageCss({
      pageId: this.page.id,
      css: this.cssValue
    }));

    if (this.modalMode) {
      this.onPageStyleModalClose();
    }
  }

  onAdditionalButtonClick(button: ButtonComponentConfig) {
    if (button.key === 'open-modal') {
      this.modalMode = true;
      setTimeout(() => {
        this.monacoEditorInModalVisibility = true;
      }, 400);
    }
  }

  onPageStyleModalClose() {
    this.modalMode = false;
    this.monacoEditorInModalVisibility = false;
  }

}
